import { getPreferredLanguage } from './languagePreference';

export const getLocaleCode = (language = getPreferredLanguage()) => (language === 'es' ? 'es-ES' : 'en-US');

export const formatLocalizedDateTime = (value, language = getPreferredLanguage(), options = {}) => {
    if (!value) return '-';
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return '-';
    return date.toLocaleString(getLocaleCode(language), options);
};

export const formatLocalizedDate = (value, language = getPreferredLanguage(), options = {}) => {
    if (!value) return '-';
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return '-';
    return date.toLocaleDateString(getLocaleCode(language), options);
};

export const formatLocalizedTime = (value, language = getPreferredLanguage(), options = {}) => {
    if (!value) return '';
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleTimeString(getLocaleCode(language), options);
};

/**
 * Formats minutes into a human-readable string with months, days, hours, and minutes
 * @param {number} minutes - The total number of minutes
 * @returns {string} - Formatted string like "1 month, 2 days, 3 hours, 45 minutes" or "-" if null/undefined
 */
export const formatTimeFromMinutes = (minutes, language = getPreferredLanguage()) => {
    if (minutes == null || minutes === 0) return '-';
    
    const totalMinutes = Math.floor(minutes);
    if (totalMinutes < 0) return '-';
    
    // Constants
    const MINUTES_PER_HOUR = 60;
    const HOURS_PER_DAY = 24;
    const DAYS_PER_MONTH = 30; // Using 30 days as a standard month for simplicity
    
    const MINUTES_PER_DAY = MINUTES_PER_HOUR * HOURS_PER_DAY;
    const MINUTES_PER_MONTH = MINUTES_PER_DAY * DAYS_PER_MONTH;
    
    // Calculate each unit
    const months = Math.floor(totalMinutes / MINUTES_PER_MONTH);
    const remainingAfterMonths = totalMinutes % MINUTES_PER_MONTH;
    
    const days = Math.floor(remainingAfterMonths / MINUTES_PER_DAY);
    const remainingAfterDays = remainingAfterMonths % MINUTES_PER_DAY;
    
    const hours = Math.floor(remainingAfterDays / MINUTES_PER_HOUR);
    const mins = remainingAfterDays % MINUTES_PER_HOUR;
    
    // Build the result string, only including non-zero values
    const parts = [];
    const labels =
        language === 'es'
            ? {
                  month: 'mes',
                  months: 'meses',
                  day: 'día',
                  days: 'días',
                  hour: 'hora',
                  hours: 'horas',
                  minute: 'minuto',
                  minutes: 'minutos'
              }
            : {
                  month: 'month',
                  months: 'months',
                  day: 'day',
                  days: 'days',
                  hour: 'hour',
                  hours: 'hours',
                  minute: 'minute',
                  minutes: 'minutes'
              };
    
    if (months > 0) {
        parts.push(`${months} ${months === 1 ? labels.month : labels.months}`);
    }
    if (days > 0) {
        parts.push(`${days} ${days === 1 ? labels.day : labels.days}`);
    }
    if (hours > 0) {
        parts.push(`${hours} ${hours === 1 ? labels.hour : labels.hours}`);
    }
    if (mins > 0 || parts.length === 0) {
        parts.push(`${mins} ${mins === 1 ? labels.minute : labels.minutes}`);
    }
    
    return parts.join(', ');
};
